import * as React from 'react';
import { Formatter } from 'utils';
import type { ArrayItem } from 'contracts/utils';
import type { Invoice } from 'contracts/tracking-v2/invoices';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from 'components/ui/table';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';

import { useToggleValuesVisibilityStore } from './toggle-values-visibility-store';

type Props = React.ComponentProps<'div'>;

export const ListItems = ({ className, ...props }: Props) => {
  const { invoice } = useInvoiceStore();
  const { visible } = useToggleValuesVisibilityStore();

  if (!invoice) {
    return (
      <div className={'flex flex-col gap-1'}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className={'w-full h-10'} />
        ))}
      </div>
    );
  }

  return (
    <div {...props} className={cn('flex flex-col gap-4', className)}>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Código do produto</TableHead>
            <TableHead>Descrição do produto</TableHead>
            <TableHead>Quantidade</TableHead>
            <TableHead>UN</TableHead>
            <TableHead>Valor</TableHead>
            <TableHead className={'text-right'}>Valor total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoice?.items?.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.prodCprod}</TableCell>
              <TableCell>{item.prodXprod}</TableCell>
              <TableCell>{item.prodQcom}</TableCell>
              <TableCell>{item.prodUcom}</TableCell>
              <TableCell>
                {visible && getItemUnitValue(item) || '********'}
              </TableCell>
              <TableCell className={'text-right'}>
                {visible && Formatter.currency(item.prodVprod) || '********'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const getItemUnitValue = (item: ArrayItem<Invoice['items']>) => {
  const { prodVuncom } = item;
  return prodVuncom ? Formatter.currency(prodVuncom) : '---';
};